/**
 * SSOの度にAuth0のCookieが残ってしまうため削除する
 * 削除対象は `com.auth0.auth.` または `_com.auth0.auth.` `co/verifier` で始まるCookieです
 * 詳細はgetDeletableCookiesを参照
 *
 * @link https://valueonepj.backlog.com/view/LA_SUITE-89 https://doctors-jp.backlog.com/view/DXUT-150
 */
export function cleanAuth0Cookies() {
  const cookies = getDeletableCookies();
  for (const cookie of cookies) {
    deleteCookie(cookie);
  }
}

/**
 * Auth0管理しているCookieを取得する. 返却するのはログインの度に溜まるもの。かつ、削除して問題ないもののみです
 * stateをキーとして利用しているため、ログインの度に増えていく情報となります
 *
 * 利用しているライブラリの以下の処理を確認したところ、デフォルトネームスペースとして定義されている'com.auth0.auth.'以下は一時的なトランザクション制御として利用しているものとわかったため削除して問題ありません
 * https://github.com/auth0/auth0.js/blob/master/src/web-auth/transaction-manager.js
 * 本来はログイン画面側ではなく、連携先のアプリケーションで利用するものですが、ログイン画面の機能としてセッション確認の処理が入っている影響で残ってしまった影響でした
 * この削除を行うタイミングは、短時間に数度のSSOを利用するタイミングとなり、削除対象は既にログインフローが完了しているstateのみになるため影響ありません
 *
 * また、SSOのために利用しているCookieはlogin-id.dx-utility.comのCookieではなく、id.dx-utility.comのドメインにCookieに保存されているもののため、このドメインのCookieを削除してもSSOの動作に影響はありません
 *
 * @todo ライブラリで提供されているclearTransactionを利用する形にするほうがベターの可能性あり
 * @link https://auth0.com/docs/manage-users/cookies/authentication-api-cookies, https://github.com/auth0/auth0.js/blob/master/src/web-auth/transaction-manager.js
 * @returns
 */
export function getDeletableCookies(cookie: string = document.cookie) {
  return cookie
    .split(/\s*;\s*/) // ;で区切る. 空白のtrimも行う
    .filter(
      (e) =>
        e.startsWith('com.auth0.auth.') || // この2種類が溜まっていくため削除対象としてフィルタリングする
        e.startsWith('_com.auth0.auth.') || //
        e.startsWith('co/verifier') // cross origin向けのcookie. こちらも同様に削除 https://github.com/auth0/auth0.js/blob/c93a683150f0128579a2150db9e4b7910cc17d90/src/web-auth/cross-origin-authentication.js#L33
    )
    .map((e) => e.split('=')[0].trim());
}
export function deleteCookie(cookie: string) {
  document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
